/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Clear_MaskInputs */

const en_landing_studio_clear_mask = /** @type {(inputs: Landing_Studio_Clear_MaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear mask`)
};

const zh_landing_studio_clear_mask = /** @type {(inputs: Landing_Studio_Clear_MaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除涂抹`)
};

/**
* | output |
* | --- |
* | "Clear mask" |
*
* @param {Landing_Studio_Clear_MaskInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_clear_mask = /** @type {((inputs?: Landing_Studio_Clear_MaskInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Clear_MaskInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_clear_mask(inputs)
	return zh_landing_studio_clear_mask(inputs)
});
export { landing_studio_clear_mask as "landing.studio.clear_mask" }